import { ListColumn, ListDataColumn } from "../ListColumn";
import { MeddraListView } from "./MeddraListView";

export class LLTListView extends MeddraListView {

    constructor(items: any) {
        let itemsWithChecked = items;
        if (itemsWithChecked && itemsWithChecked.length>0) {
            itemsWithChecked = items.map((info: any) => ({checked: false, ...info}));
        }

        const itemFinderArrayColumns: ListColumn[] = [
            new ListColumn("Num", ListDataColumn.TEXT, "num"),
            new ListColumn("LLT Name", ListDataColumn.TEXT, "name"),
            new ListColumn("LLT Code", ListDataColumn.TEXT, "code"),
            new ListColumn("Is Deprecated?", ListDataColumn.TEXT, "lltDeprecated")
        ];
        const itemFinderTreeColumns: ListColumn[] = [
            new ListColumn("LLT Name", ListDataColumn.TEXT, "name"),
            new ListColumn("LLT Code", ListDataColumn.TEXT, "code"),
            new ListColumn("Is Deprecated?", ListDataColumn.TEXT, "lltDeprecated")
        ];

        super(itemsWithChecked,  itemFinderArrayColumns, itemFinderTreeColumns);                
    }

}